import React from "react";

export const ACH_ICONS = [
    ["bi-award-fill", "Award"], ["bi-book-fill", "Constitution / Book"], ["bi-signpost-2-fill", "Roads / Infrastructure"],
    ["bi-handshake", "Diplomacy"], ["bi-people-fill", "People / Unity"], ["bi-heart-pulse-fill", "Health / Welfare"],
    ["bi-graph-up-arrow", "Economy"], ["bi-shield-check", "Security / Relief"], ["bi-mortarboard-fill", "Education"],
    ["bi-lightning-charge-fill", "Energy"], ["bi-tree-fill", "Environment"], ["bi-trophy-fill", "Trophy"],
];

export const ACH_CATEGORIES = [
    ["political", "Political"], ["development", "Development"], ["international", "International"], ["social", "Social"],
];

const emptyAchievement = { title: "", title_np: "", year: "", description: "", description_np: "", icon: "bi-award-fill", category: "political" };
const emptyTimelineEntry = { year: "", title: "", title_np: "", description: "", description_np: "" };

export default function PoliticalAchievementsTab({ achievements, setAchievements, timeline, setTimeline }) {
    const updList = (list, setList, i, key, val) => {
        const c = [...list];
        c[i] = { ...c[i], [key]: val };
        setList(c);
    };
    const removeAt = (list, setList, i) => setList(list.filter((_, idx) => idx !== i));

    return (
        <div>
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Key Achievements</span>
                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setAchievements([...achievements, { ...emptyAchievement }])}>
                        <i className="bi bi-plus-lg me-1" />Add Achievement
                    </button>
                </div>
                <div className="card-body">
                    {achievements.length === 0 ? (
                        <p className="text-muted mb-0">No achievements added yet.</p>
                    ) : achievements.map((a, i) => (
                        <div className="border rounded p-3 mb-3" key={i}>
                            <div className="row g-2">
                                <div className="col-md-2">
                                    <label className="form-label small text-muted">Year</label>
                                    <input className="form-control form-control-sm" placeholder="2020" value={a.year || ""} onChange={(e) => updList(achievements, setAchievements, i, "year", e.target.value)} />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label small text-muted">Icon</label>
                                    <select className="form-select form-select-sm" value={a.icon || "bi-award-fill"} onChange={(e) => updList(achievements, setAchievements, i, "icon", e.target.value)}>
                                        {ACH_ICONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label small text-muted">Category (card colour)</label>
                                    <select className="form-select form-select-sm" value={a.category || "political"} onChange={(e) => updList(achievements, setAchievements, i, "category", e.target.value)}>
                                        {ACH_CATEGORIES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-2 d-flex align-items-end">
                                    <button type="button" className="btn btn-sm btn-outline-danger w-100" onClick={() => removeAt(achievements, setAchievements, i)}><i className="bi bi-trash" /></button>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">Title</label>
                                    <input className="form-control form-control-sm" value={a.title || ""} onChange={(e) => updList(achievements, setAchievements, i, "title", e.target.value)} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">शीर्षक (Nepali)</label>
                                    <input className="form-control form-control-sm" value={a.title_np || ""} onChange={(e) => updList(achievements, setAchievements, i, "title_np", e.target.value)} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">Description</label>
                                    <textarea rows="2" className="form-control form-control-sm" value={a.description || ""} onChange={(e) => updList(achievements, setAchievements, i, "description", e.target.value)} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">विवरण (Nepali)</label>
                                    <textarea rows="2" className="form-control form-control-sm" value={a.description_np || ""} onChange={(e) => updList(achievements, setAchievements, i, "description_np", e.target.value)} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Career Timeline</span>
                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setTimeline([...timeline, { ...emptyTimelineEntry }])}>
                        <i className="bi bi-plus-lg me-1" />Add Event
                    </button>
                </div>
                <div className="card-body">
                    {timeline.length === 0 ? (
                        <p className="text-muted mb-0">No timeline events added yet.</p>
                    ) : timeline.map((t, i) => (
                        <div className="border rounded p-3 mb-3" key={i}>
                            <div className="row g-2">
                                <div className="col-md-2">
                                    <label className="form-label small text-muted">Year</label>
                                    <input className="form-control form-control-sm" placeholder="2015" value={t.year || ""} onChange={(e) => updList(timeline, setTimeline, i, "year", e.target.value)} />
                                </div>
                                <div className="col-md-5">
                                    <label className="form-label small text-muted">Event Title</label>
                                    <input className="form-control form-control-sm" placeholder="e.g. Elected to Parliament" value={t.title || ""} onChange={(e) => updList(timeline, setTimeline, i, "title", e.target.value)} />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label small text-muted">शीर्षक (Nepali)</label>
                                    <input className="form-control form-control-sm" value={t.title_np || ""} onChange={(e) => updList(timeline, setTimeline, i, "title_np", e.target.value)} />
                                </div>
                                <div className="col-md-1 d-flex align-items-end">
                                    <button type="button" className="btn btn-sm btn-outline-danger w-100" onClick={() => removeAt(timeline, setTimeline, i)}><i className="bi bi-trash" /></button>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">Description</label>
                                    <textarea rows="2" className="form-control form-control-sm" value={t.description || ""} onChange={(e) => updList(timeline, setTimeline, i, "description", e.target.value)} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">विवरण (Nepali)</label>
                                    <textarea rows="2" className="form-control form-control-sm" value={t.description_np || ""} onChange={(e) => updList(timeline, setTimeline, i, "description_np", e.target.value)} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}